<main class="component-wrapper">
    <div class="component-content" id="main-content">
        <header>
            <div>
                <h1 [trimRichtextAriaLabel]="willkommenstext | translate" class="willkommens-text"
                    [innerHTMLBypassXSS]="willkommenstext"></h1>
            </div>
            <div class="info-text" [trimRichtextAriaLabel]="infotextUebersicht | translate">
                <p [innerHTMLBypassXSS]="infotextUebersicht"></p>
            </div>
        </header>

        <!-- Suchfeld und Förderprogramm-Filter -->
        @if(!isEmpty && (config.SEARCH_VISIBLE || config.FILTER_VISIBLE)) {
        <div class="filter-section">
            @if(config.SEARCH_VISIBLE) {
            <div class="search-wrapper">
                <lucide-icon name="search" [size]="20" class="search-icon"></lucide-icon>
                <kendo-textbox [placeholder]="'ausschreibung.search.placeholder' | translate" [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearchChange()" class="search-input" style="padding-left:2rem;">
                </kendo-textbox>
            </div>
            }
            @if (config.FILTER_VISIBLE && showFoerderprogrammFilter) {
            <div class="foerderprogramm-filter">
                <button kendoButton *ngFor="let filter of foerderprogrammFilters" class="filter-pill"
                    [class.active]="selectedFoerderprogrammId === filter.id"
                    (click)="onFoerderprogrammChange(filter.id)">
                    {{ filter.title }}
                </button>
            </div>
            }
        </div>
        }

        <!-- Gruppiert nach Förderprogramm -->
        @if (sortByFoerderprogramme && filteredFoerderprogramme.length > 0) {
        <section class="ausschreibung-foerderbereich"
            *ngFor="let foerderbereich of filteredFoerderprogramme; let i = index;">
            <h1>{{foerderbereich.title}}</h1>
            <div class="ausschreibungen-grid">
                <ausschreibung-card *ngFor="let ausschreibung of foerderbereich.ausschreibungen"
                    [ausschreibung]="ausschreibung" [foerderprogrammName]="foerderbereich.title ?? undefined">
                </ausschreibung-card>
            </div>
        </section>
        }
        <!-- Sortiert nach Ausschreibungsname (keine Förderprogramm-Gruppierung) -->
        @else if (sortByAusschreibungsname && filteredAusschreibungen.length > 0) {
        <section>
            <div class="ausschreibungen-grid">
                @for(ausschreibung of filteredAusschreibungen; track ausschreibung.id) {
                    <ng-container *ngComponentOutlet="ausschreibungCardComponent, inputs: {
                        ausschreibung: ausschreibung
                    }"></ng-container>
                }
            </div>
        </section>
        }

        <!-- Leerzustand -->
        @if(isEmpty || isEmptySearchResult) {
        <div class="empty-state">
            @if(isEmpty) {
            <p class="empty-text">{{ 'tender.none_available' | translate }}</p>
            }
            @else if(isEmptySearchResult) {
            <lucide-icon name="file-text" [size]="64" class="empty-icon"></lucide-icon>
            <p class="empty-text">{{ 'ausschreibung.no_results' | translate }}</p>
            }
        </div>
        }
    </div>
</main>